<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form #auroraSubmitForm="ngForm"
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <ep-row>
          <div class="col-12 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Condition_Name">Condition Name</label>
              <input
                type="text"
                name="Condition_Name"
                class="form-control"
                [(ngModel)]="dsCollection.criteria.Condition_Name"
                ngControl="Condition_Name"
                (valueChange)="model.dirty = true"
              />
            </div>
          </div>

          <div class="col-12 col-lg-8">
            <aurora-button
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="submit"
              [loading]="dsCollection && dsCollection.status == 'Loading'"
              variant="primary"
              (click)="auroraSubmitForm.onSubmit($event)"
            >
              Search
            </aurora-button>
          </div>
        </ep-row>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-filter-input
          #conditionFilter
          style="margin-bottom: 5px"
          [filter]="{ filterKey: '[GLOBAL]', maxDepth: 5 }"
        ></ep-filter-input>

        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>

        <div
          class="table-responsive"
          style="max-height: 400px; min-height: 400px; overflow-y: scroll; margin-top: 5px; border: 1px solid silver"
        >
          <table class="table table-select table-fixed-header" style="min-width: 700px">
            <tr>
              <th *ngIf="model.currentOptions.allowMultiSelect === true"></th>
              <th>Condition Name</th>
              <th>Condition Text</th>
              <th>Collating Seq</th>
            </tr>
            <tr
              [class.active]="condition.Selected"
              *ngFor="
                let condition of dsCollection.objectNodes
                  | epFilter : conditionFilter.filter : conditionFilter.filter.filterText
              "
              (click)="app.getSelectedText() && recordClicked(condition, $event)"
            >
              <td
                *ngIf="model.currentOptions.allowMultiSelect === true"
                style="text-align: center"
                (click)="app.stopNavigation($event)"
              >
                <i
                  *ngIf="!condition.Selected"
                  class="fa fa-ep-selected-false-square"
                  style="margin-top: 3px"
                  (click)="checkboxClicked(condition)"
                ></i>
                <i
                  *ngIf="condition.Selected"
                  class="fa fa-ep-selected-square"
                  style="margin-top: 3px"
                  (click)="checkboxClicked(condition)"
                ></i>
              </td>
              <td>
                {{ condition.Condition_Name }}
              </td>
              <td>
                {{ condition.Condition_Text }}
              </td>
              <td>
                {{ condition.Collating_Seq }}
              </td>
            </tr>

            <tr
              class="col-12"
              *ngIf="
                !(dsCollection.objectNodes && dsCollection.objectNodes.length > 0) && dsCollection.status == 'Ready'
              "
            >
              <td>
                <span style="text-align: center"><i>No Conditions</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
